import {
    useAccessibleTooltip,
    type UseAccessibleTooltipParams
} from 'app/components/core/AccessibleTooltip';
import { ErrorTooltip } from './ErrorTooltip';

export function useErrorTooltip(params: UseAccessibleTooltipParams = {}) {
    const { placement = 'bottom-start', ...others } = params;
    const { refs, getReferenceProps, getTooltipProps } = useAccessibleTooltip({
        placement,
        ...others
    });

    return { ErrorTooltip, refs, getReferenceProps, getTooltipProps };
}
